export function displayCheckerboard (numRows = 10, numCols = 42, colors = ['blue', 'white']) {
  const rows = []

  for(let i = 0; i < numRows; i++) {
    rows.push(displayCheckerboardRow(numCols, colors))
    colors = [colors[1], colors[0]]
  }

  return (
    <div className='checkerboard'>
      { rows }
    </div>
  )
}

function displayCheckerboardRow (numCols, colors) {
  const cols = []
  let color;

  for(let i = 0; i < numCols; i++) {
    color = colors[i % 2]
    cols.push(displayChecker(color))
  }

  return (
    <div className='checkerboard-row'>
      { cols }
    </div>
  )
}

function displayChecker (color) {
  if (color == 'multi') {
    const colors = ['blue', 'seersucker-blue', 'deep-blue', 'green', 'deep-green', 'pink', 'deep-pink']
    color = colors[Math.floor(Math.random() * colors.length)];
  }

  return (
    <div className={ `checker ${color}` }></div>
  )
}
